// Converted to .ts file on 23 June, 2025
import store from '@/redux/store';
import { getSSRStore } from 'src/redux';
/**
 * returns name of category given categoryID or TagId
 * @param {number} id categoryId or TagId
 * @return {string} name of category or Tag
 */
function getCategoryname(id, reducer = store.getState()) {
  const categories = reducer?.catalogReducer?.categories;
  const tags = reducer?.catalogReducer?.productTags;
  if (!categories?.length && !tags?.length) return '';

  const categoryTagDetails = [...categories, ...tags].find((categoryItem) => id === categoryItem?.id);

  // if categoryTagDetails is undefined return "all" as category name
  if (!categoryTagDetails?.name) return 'all';

  return categoryTagDetails.name;
}

export function getCategoryTagNameFromId(id) {
  return getCategoryname(id);
}

export function getCategoryTagNameFromIdSSR(id, domain) {
  const reducer = getSSRStore(domain);
  const categoryName = getCategoryname(id, reducer);
  return categoryName?.replace(/ /g, '').replace(/\//g, '-');
}
